import { createSlice } from "@reduxjs/toolkit";

const emptyDuplicatesState = {
  records: [],
  groups: [],
  loading: false,
  lastFetchedAt: null,
};

export const contactsPageSlice = createSlice({
  name: "contactsPageState",
  initialState: {
    filters: {
      page: 1,
      sortFilter: "id",
      sortAscending: true,
      searchWord: "",
      cityFilter: "",
      tagsFilter: [],
    },
    contactsList: [],
    citiesList: [],
    tagsList: [],
    duplicates: { ...emptyDuplicatesState },
  },
  reducers: {
    updateFilters: (state, action) => {
      state.filters = action.payload;
    },
    updateContactsList: (state, action) => {
      const contactsList = action.payload;
    
      // Check if contactsList is an array
      if (Array.isArray(contactsList)) {
        state.contactsList = contactsList;
      } else {
        state.contactsList = []; // Set to an empty array if not an array
      }
    },
    updateFacetLists: (state, action) => {
      const { cities, tags } = action.payload || {};
      state.citiesList = Array.isArray(cities) ? cities : [];
      state.tagsList = Array.isArray(tags) ? tags : [];
    },
    updateDuplicates: (state, action) => {
      const payload = action.payload || {};
      if (!state.duplicates) state.duplicates = { ...emptyDuplicatesState };
      state.duplicates.records = Array.isArray(payload.records) ? payload.records : [];
      state.duplicates.groups = Array.isArray(payload.groups) ? payload.groups : [];
      state.duplicates.lastFetchedAt = payload.lastFetchedAt || Date.now();
    },
    setDuplicatesLoading: (state, action) => {
      if (!state.duplicates) state.duplicates = { ...emptyDuplicatesState };
      state.duplicates.loading = !!action.payload;
    },
    resetStateContactsPage: (state) => {
      state.filters = {
        page: 1,
        sortFilter: "id",
        sortAscending: true,
        searchWord: "",
        cityFilter: "",
        tagsFilter: [],
      };
      state.contactsList = [];
      state.citiesList = [];
      state.tagsList = [];
      state.duplicates = { ...emptyDuplicatesState };
    },
  },
})

export const { updateFilters, updateContactsList, updateFacetLists, updateDuplicates, setDuplicatesLoading, resetStateContactsPage } = contactsPageSlice.actions
export default contactsPageSlice.reducer
